/**
 * A name rather than the page's document: importing that module pulls the whole Overview page into
 * the graph of every component that refetches it, the shared household header included.
 *
 * Its own leaf module for the same reason — `add-family-member-dialog` carries MUI's date pickers,
 * formik and yup, which the header's create menu is deliberately lazy about.
 */
export const OVERVIEW_QUERY_NAME = 'AdvisorDashboardClientSalesforceAccountId';
